import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import icons from "../../../../../assets/images/icons";
import { useRoomDisplayMeta } from "../../../hooks/useRoomDisplayMeta";
import ChatRoomMoreModal from "../ChatRoomMoreModal/ChatRoomMoreModal";
import styles from "./ChatRoomPageHeader.module.scss";
/**
 * 채팅방 화면 상단 헤더 (01_CHAT 0.0.7 - Figma 대화 상세페이지)
 * 뒤로가기 + 아바타 + 대표명 + 더보기(More vertical)
 */
function ChatRoomPageHeader({
  className = "",
  room = null,
  title: titleFallback = "",
  avatarUrl: avatarFallback,
  blockedByMe,
  blockedByOther,
  onBack,
  onMoreClick,
  isMoreOpen = false,
  otherUserId = "",
  onMoreClose,
  onReport,
  onBlock,
  onUnblock,
  onNotification,
  onLeave,
}) {
  const moreBtnRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (!isMoreOpen) return;
    const handleResize = () => onMoreClose?.();
    const handlePointerDown = (e) => {
      if (moreBtnRef.current?.contains(e.target) || modalRef.current?.contains(e.target)) return;
      onMoreClose?.();
    };
    window.addEventListener("resize", handleResize);
    document.addEventListener("pointerdown", handlePointerDown);
    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, [isMoreOpen, onMoreClose]);
  const { displayName, avatarUrl: metaAvatar } = useRoomDisplayMeta(room);
  const hasRoom = room?.id != null && String(room.id) !== "";
  const title = hasRoom ? displayName || titleFallback || "채팅" : titleFallback || "채팅";
  const avatarUrl = hasRoom ? (metaAvatar ?? avatarFallback) : avatarFallback;

  const getModalStyle = () => {
    if (!moreBtnRef.current) return {};
    const rect = moreBtnRef.current.getBoundingClientRect();
    const isMobile = window.innerWidth <= 768;
    return {
      position: "fixed",
      top: rect.bottom + 8,
      zIndex: 9999,
      ...(isMobile ? { right: window.innerWidth - rect.right } : { left: rect.left }),
    };
  };

  return (
    <div
      className={`${styles.root} ${className}`.trim()}
      data-name="Chat room header"
      data-node-id="40004313:31147"
    >
      <div className={`${styles.bar} ${blockedByMe ? styles.barBlocked : ""}`}>
        <div className={styles.nav}>
          <button type="button" className={styles.backBtn} onClick={onBack} aria-label="뒤로">
            <img src={icons.messager?.chevronLeft} alt="" className={styles.backIcon} />
          </button>
          <div className={styles.profile}>
            <div className={styles.avatarWrap}>
              {avatarUrl ? (
                <img src={avatarUrl} alt="" className={styles.avatarImg} width={32} height={32} />
              ) : (
                <img src={icons.messager?.person} alt="" className={styles.avatarIcon} />
              )}
            </div>
            <h1 className={styles.title}>{title}</h1>
            {blockedByMe && <span className={styles.blockedBadge}>차단한 사용자</span>}
            {blockedByOther && <span className={styles.blockedBadge}>나를 차단한 사용자</span>}
          </div>
          <div className={styles.moreBtnWrap}>
            <button
              ref={moreBtnRef}
              type="button"
              className={styles.moreBtn}
              onClick={onMoreClick}
              aria-label="더보기"
            >
              <img
                src={icons.messager?.moreVertical}
                alt=""
                className={styles.moreIcon}
                width={24}
                height={24}
              />
            </button>
          </div>
          {isMoreOpen &&
            ReactDOM.createPortal(
              <ChatRoomMoreModal
                ref={modalRef}
                style={getModalStyle()}
                otherUserId={otherUserId}
                blockedByMe={blockedByMe}
                onReport={onReport}
                onBlock={onBlock}
                onUnblock={onUnblock}
                onNotification={onNotification}
                onLeave={onLeave}
                onClose={onMoreClose}
              />,
              document.body
            )}
        </div>
        <div className={styles.divider} />
      </div>
    </div>
  );
}

export default ChatRoomPageHeader;
